var map = {
	"./indexSlides/210512_更新完成_en.png": 54769,
	"./indexSlides/210512_更新完成_jp.png": 67861,
	"./indexSlides/210512_更新完成_kr.png": 89594,
	"./indexSlides/210512_更新完成_sc.png": 82403,
	"./indexSlides/210512_更新完成_tc.png": 89025,
	"./indexSlides/210519_魔獄塔更新熱更完成公告_en.png": 65817,
	"./indexSlides/210519_魔獄塔更新熱更完成公告_jp.png": 85870,
	"./indexSlides/210519_魔獄塔更新熱更完成公告_kr.png": 45269,
	"./indexSlides/210519_魔獄塔更新熱更完成公告_sc.png": 98073,
	"./indexSlides/210519_魔獄塔更新熱更完成公告_tc.png": 2647,
	"./indexSlides/210519_魔獄塔更新熱更預告_en.png": 87446,
	"./indexSlides/210519_魔獄塔更新熱更預告_jp.png": 73097,
	"./indexSlides/210519_魔獄塔更新熱更預告_kr.png": 13762,
	"./indexSlides/210519_魔獄塔更新熱更預告_sc.png": 22040,
	"./indexSlides/210519_魔獄塔更新熱更預告_tc.png": 45349,
	"./indexSlides/210521_妲絲刷關活動熱更預告_en.png": 58241,
	"./indexSlides/210521_妲絲刷關活動熱更預告_jp.png": 82624,
	"./indexSlides/210521_妲絲刷關活動熱更預告_kr.png": 83777,
	"./indexSlides/210521_妲絲刷關活動熱更預告_sc.png": 37981,
	"./indexSlides/210521_妲絲刷關活動熱更預告_tc.png": 62499,
	"./indexSlides/210526_妲絲刷關活動熱更完成_en.png": 27895,
	"./indexSlides/210526_妲絲刷關活動熱更完成_jp.png": 79191,
	"./indexSlides/210526_妲絲刷關活動熱更完成_kr.png": 63132,
	"./indexSlides/210526_妲絲刷關活動熱更完成_sc.png": 82962,
	"./indexSlides/210526_妲絲刷關活動熱更完成_tc.png": 48226,
	"./indexSlides/210528_夏日角色熱更預告_en.png": 22317,
	"./indexSlides/210528_夏日角色熱更預告_jp.png": 92258,
	"./indexSlides/210528_夏日角色熱更預告_kr.png": 83123,
	"./indexSlides/210528_夏日角色熱更預告_sc.png": 11627,
	"./indexSlides/210528_夏日角色熱更預告_tc.png": 64445,
	"./indexSlides/210602_夏日活動強更預告_en.png": 54475,
	"./indexSlides/210602_夏日活動強更預告_jp.png": 62779,
	"./indexSlides/210602_夏日活動強更預告_kr.png": 31103,
	"./indexSlides/210602_夏日活動強更預告_sc.png": 3318,
	"./indexSlides/210602_夏日活動強更預告_tc.png": 86222,
	"./indexSlides/220803_天下布魔更新內容預告_all.png": 2866,
	"./indexSlides/220803_天下布魔更新內容預告_chs.png": 10981,
	"./indexSlides/220803_天下布魔更新內容預告_en.png": 89906,
	"./indexSlides/220803_天下布魔更新內容預告_jp.png": 99808,
	"./indexSlides/220803_天下布魔更新內容預告_kr.png": 61606,
	"./indexSlides/cht.png": 88048,
	"./indexSlides/en1.png": 60944,
	"./indexSlides/jp1.png": 33070,
	"./indexSlides/kr1.png": 18448,
	"./indexSlides/天下第一配音徵選_BN.png": 52674,
	"./indexSlidesWebp/210512_更新完成_en.webp": 17034,
	"./indexSlidesWebp/210512_更新完成_jp.webp": 10048,
	"./indexSlidesWebp/210512_更新完成_kr.webp": 78631,
	"./indexSlidesWebp/210512_更新完成_sc.webp": 37912,
	"./indexSlidesWebp/210512_更新完成_tc.webp": 38775,
	"./indexSlidesWebp/210519_魔獄塔更新熱更完成公告_en.webp": 63180,
	"./indexSlidesWebp/210519_魔獄塔更新熱更完成公告_jp.webp": 33576,
	"./indexSlidesWebp/210519_魔獄塔更新熱更完成公告_kr.webp": 58027,
	"./indexSlidesWebp/210519_魔獄塔更新熱更完成公告_sc.webp": 22885,
	"./indexSlidesWebp/210519_魔獄塔更新熱更完成公告_tc.webp": 45021,
	"./indexSlidesWebp/210519_魔獄塔更新熱更預告_en.webp": 43645,
	"./indexSlidesWebp/210519_魔獄塔更新熱更預告_jp.webp": 59113,
	"./indexSlidesWebp/210519_魔獄塔更新熱更預告_kr.webp": 35531,
	"./indexSlidesWebp/210519_魔獄塔更新熱更預告_sc.webp": 20510,
	"./indexSlidesWebp/210519_魔獄塔更新熱更預告_tc.webp": 57968,
	"./indexSlidesWebp/210521_妲絲刷關活動熱更預告_en.webp": 84958,
	"./indexSlidesWebp/210521_妲絲刷關活動熱更預告_jp.webp": 27089,
	"./indexSlidesWebp/210521_妲絲刷關活動熱更預告_kr.webp": 97801,
	"./indexSlidesWebp/210521_妲絲刷關活動熱更預告_sc.webp": 39556,
	"./indexSlidesWebp/210521_妲絲刷關活動熱更預告_tc.webp": 11461,
	"./indexSlidesWebp/210526_妲絲刷關活動熱更完成_en.webp": 69613,
	"./indexSlidesWebp/210526_妲絲刷關活動熱更完成_jp.webp": 94013,
	"./indexSlidesWebp/210526_妲絲刷關活動熱更完成_kr.webp": 20398,
	"./indexSlidesWebp/210526_妲絲刷關活動熱更完成_sc.webp": 44191,
	"./indexSlidesWebp/210526_妲絲刷關活動熱更完成_tc.webp": 57889,
	"./indexSlidesWebp/210528_夏日角色熱更預告_en.webp": 38247,
	"./indexSlidesWebp/210528_夏日角色熱更預告_jp.webp": 18374,
	"./indexSlidesWebp/210528_夏日角色熱更預告_kr.webp": 45649,
	"./indexSlidesWebp/210528_夏日角色熱更預告_sc.webp": 24188,
	"./indexSlidesWebp/210528_夏日角色熱更預告_tc.webp": 939,
	"./indexSlidesWebp/210602_夏日活動強更預告_en.webp": 29922,
	"./indexSlidesWebp/210602_夏日活動強更預告_jp.webp": 1799,
	"./indexSlidesWebp/210602_夏日活動強更預告_kr.webp": 50044,
	"./indexSlidesWebp/210602_夏日活動強更預告_sc.webp": 4140,
	"./indexSlidesWebp/210602_夏日活動強更預告_tc.webp": 41044,
	"./indexSlidesWebp/220803_天下布魔更新內容預告_all.webp": 20998,
	"./indexSlidesWebp/220803_天下布魔更新內容預告_chs.webp": 50399,
	"./indexSlidesWebp/220803_天下布魔更新內容預告_en.webp": 51473,
	"./indexSlidesWebp/220803_天下布魔更新內容預告_jp.webp": 74679,
	"./indexSlidesWebp/220803_天下布魔更新內容預告_kr.webp": 66223,
	"./indexSlidesWebp/cht.webp": 42763,
	"./indexSlidesWebp/en1.webp": 78415,
	"./indexSlidesWebp/jp1.webp": 23794,
	"./indexSlidesWebp/kr1.webp": 15912,
	"./indexSlidesWebp/天下第一配音徵選_BN.webp": 97536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97572;